const CDI_FALLBACK = 'CDI'

export const buildBenchmarkMapper = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : []
  const mapper = {}
  applyRowsByAttribute(mapper, safeRows, 'classe')
  applyRowsByAttribute(mapper, safeRows, 'subclasse')
  return mapper
}

const applyRowsByAttribute = (mapper, rows, attribute) => {
  for (const row of rows) {
    if (!row || row.atributo !== attribute) continue
    const key = row.valor_atributo
    if (key === null || key === undefined || key === '') continue
    mapper[key] = row.benchmark
  }
}

export const resolveGroupBenchmark = ({ groupKey, ativos, mapper } = {}) => {
  const safeMapper = mapper && typeof mapper === 'object' ? mapper : {}

  const direct = lookupBenchmark(safeMapper, groupKey)
  if (direct) return direct

  const safeAtivos = Array.isArray(ativos) ? ativos : []
  if (safeAtivos.length === 0) return CDI_FALLBACK

  const subclasses = collectUniqueValues(safeAtivos, resolveSubclasseValue)
  if (subclasses.length === 1) {
    const bySubclasse = lookupBenchmark(safeMapper, subclasses[0])
    if (bySubclasse) return bySubclasse
  }

  const classes = collectUniqueValues(safeAtivos, resolveClasseValue)
  if (classes.length === 1) {
    const byClasse = lookupBenchmark(safeMapper, classes[0])
    if (byClasse) return byClasse
  }

  return CDI_FALLBACK
}

export const resolveClassRowBenchmark = ({
  grupo,
  breakdownData,
  groupBenchmark,
  mapper,
} = {}) => {
  const safeGrupo = grupo || {}
  const fromPayload = readText(safeGrupo.benchmark)
  if (fromPayload) return fromPayload
  const entry = (breakdownData || {})[safeGrupo.grupo]
  const fromBreakdown = readText(entry && entry.benchmark_relativo_nome)
  if (fromBreakdown) return fromBreakdown
  if (groupBenchmark) return groupBenchmark
  return resolveGroupBenchmark({
    groupKey: safeGrupo.grupo,
    ativos: safeGrupo.ativos,
    mapper,
  })
}

const readText = (value) => (typeof value === 'string' ? value.trim() : '')

const lookupBenchmark = (mapper, key) => {
  if (!key) return null
  const value = mapper[key]
  if (value === null || value === undefined || value === '') return null
  return value
}

const resolveSubclasseValue = (ativo) => {
  if (!ativo) return ''
  const subclasse = normalizeValue(ativo.subclasse)
  if (subclasse) return subclasse
  return normalizeValue(ativo.classe)
}

const resolveClasseValue = (ativo) => {
  if (!ativo) return ''
  return normalizeValue(ativo.classe)
}

const normalizeValue = (value) => {
  if (value === null || value === undefined) return ''
  const text = String(value).trim()
  return text === '' ? '' : value
}

const collectUniqueValues = (ativos, resolver) => {
  const unique = []
  for (const ativo of ativos) {
    const value = resolver(ativo)
    if (value === '' || value === null || value === undefined) continue
    if (!unique.includes(value)) unique.push(value)
  }
  return unique
}
